import webdev from '../images/18.png'
import appdev from '../images/16.png'
import emaildev from '../images/14.png'
import notificationdev from '../images/15.png'
import socialdev from '../images/17.png'
import support from '../images/rocket.png'
import vision from '../images/22.png'
import mission from '../images/23.png'
import about from '../images/fe4.png'

export const services = [
                    {
                        id: 1,
                        img: webdev,
                        title: 'Web Development',
                        description: 'Craft a powerful online presence with our responsive and visually appealing websites tailored to your brand.'
                },
                {
                    id: 2,
                    img: webdev,
                    title: 'App Development',
                    description: 'Make your ideas into reality with feature-rich mobile apps for iOS and Android, ensuring user-friendly interfaces and seamless functionality.'
                },
               {              
                              id: 3,
                              img: emaildev,
                              title: 'Software Development',
                              description: 'Transform your vision into reality with our team of skilled professionals. We create custom, efficient software solutions, ensuring security and a seamless user experience.'

               },
               {
                              id: 4,
                              img: appdev,
                              title: 'Database Administration',
                              description: 'Streamline data management for optimal security, integrity, and performance.'
               },
               {
                              id: 5,
                              img: notificationdev,
                              title: 'Digital Marketing',
                              description: 'Boost online visibility and engagement with effective digital marketing strategies, including social media campaigns and SEO'
               },
               {
                              id: 6,
                              img: socialdev,
                              title: 'Social Media Marketing',
                              description: "Boost your brand's online presence with strategic social media efforts."
               },
               {
                              id: 7,
                              img: support,
                              title: 'IT Consulting',
                              description: 'Stay ahead in tech with our IT consulting services, optimizing your infrastructure for performance, security, and efficiency.'
               }

]

export const aboutdet = [
               {
                              id: 1,
                              img: vision,
                              title: 'Our Mission',
                              description: "To transform ideas into digital realities and empower businesses to thrive in the digital age."
               },
               {
                              id: 2,
                              img: mission,
                              title: 'Our Vision',
                              description: "Our vision is to carryout researches,and develop technological solutions that will help both small and large businesses excel globally."
               },
               {
                              id: 3,
                              img: about,
                              title: 'Our Objective',
                              description: 'Build and develop A-grade enterprise solutions for companies and build teams to manage them.'
               },
]